// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: contents;
}

.snackbar {
  display: flex;
  flex-flow: column;
}
.snackbar-header {
  display: grid;
  grid-template-columns: auto 1fr auto;
  column-gap: 10px;
  align-items: center;
  padding: 10px 20px;
}
.snackbar-header-success {
  background-color: var(--color-success);
}
.snackbar-header-info {
  background-color: var(--color-info);
}
.snackbar-header-warning {
  background-color: var(--color-warning);
}
.snackbar-header-error {
  background-color: var(--color-error);
}
.snackbar-header-default {
  background-color: #525257;
}
.snackbar-message {
  padding: 10px 20px;
  background-color: white;
  color: var(--color-text);
  word-break: break-word;
}

.mat-icon {
  height: 18px;
  width: 18px;
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/view/control/custom-snackbar/custom-snackbar.component.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ;;AAIA;EACI,aAAA;EACA,iBAAA;AADJ;AAEI;EACI,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AACQ;EACI,sCAAA;AACZ;AACQ;EACI,mCAAA;AACZ;AACQ;EACI,sCAAA;AACZ;AACQ;EACI,oCAAA;AACZ;AACQ;EACI,yBAAA;AACZ;AAEI;EACI,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;AAAR;;AAIA;EACI,YAxCO;EAyCP,WAzCO;EA0CP,eA1CO;AAyCX","sourcesContent":["$iconSize: 18px;\n\n:host {\n    display: contents;\n}\n\n.snackbar {\n    display: flex;\n    flex-flow: column;\n    &-header {\n        display: grid;\n        grid-template-columns: auto 1fr auto;\n        column-gap: 10px;\n        align-items: center;\n        padding: 10px 20px;\n        &-success {\n            background-color: var(--color-success);\n        }\n        &-info {\n            background-color: var(--color-info);\n        }\n        &-warning {\n            background-color: var(--color-warning);\n        }\n        &-error {\n            background-color: var(--color-error);\n        }\n        &-default {\n            background-color: #525257;\n        }\n    }\n    &-message {\n        padding: 10px 20px;\n        background-color: white;\n        color: var(--color-text);\n        word-break: break-word;\n    }\n}\n\n.mat-icon {\n    height: $iconSize;\n    width: $iconSize;\n    font-size: $iconSize;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
